import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../../../components/CustomText";
import CustomBoard from "../../../../components/CustomBoard";
import "fontsource-muli";
import CustomButton from "../../../../components/CustomButton";
import { withRouter } from "react-router-dom";
import AuthManager from "../../../../../utils/AuthManager";
import Image from "../../../../../assets";
class ReceivedUserID extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // otp: "",
      height: 0,
      localUserID:""
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    await AuthManager.retrieveUserID().then((value) => {
      if (value) {
   
        this.setState({ localUserID: value });
     
      }
    });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
    // AuthManager.removeUserID();
  }

  updateWindowDimensions() {
    this.setState({ height: window.innerHeight });
  }

  onClickReturnToLogin = () => {
    const {history} = this.props;
    history.push("/Login")
    window.location.reload(false);
  };

  renderChildren = () => {
    const { classes } = this.props;
    const { otp } = this.state;
    //const { userId } = this.props.location.state;
    
    return (
      <div className={classes.contentContainer}>
        <img src={Image.celebrativeIcon} />
        <CustomText design={classes.headerTextStyle}>Your User ID Is</CustomText>
        <div className={classes.userIDContainer}>
          <CustomText design={classes.userIDTextStyle}>{this.state.localUserID}</CustomText>
        </div>

        <CustomButton
          title={"Back to login"}
          design={classes.buttonStyle}
          onClick={this.onClickReturnToLogin}
        />
      </div>
    );
  };

  render() {
    const { classes } = this.props;
    const { height } = this.state;
    return (
      <div className={classes.root}>
        <CustomBoard children={this.renderChildren()} height={height} />
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "white",
  },
  headerTextStyle: {
    ...getFontWeight("400"),
    fontSize: 16,
    textAlign: "left",
    color: "#000000",
    marginTop:'1rem'
  },
 userIDContainer:{
  //  width: 190,
   borderRadius: 5,
   //backgroundColor: "#eaeef2",
   marginTop: 0,
   marginBottom: 20,
   paddingLeft: 20,
   paddingRight: 20,
   paddingTop: 5,
   paddingBottom: 5,
   textAlign:'center'
 },
  userIDTextStyle:{
    fontSize: 32,
    ...getFontWeight("bold"),
    color: "#000000"
  },
  buttonStyle: {
    // width: 200,
    height:'48px'
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
}
});

export default withStyles(styles, { withTheme: true })(
  withRouter(ReceivedUserID)
);
